module.exports = __webpack_public_path__ + "img/ilma.e9bd5e04.svg";